/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'refuse': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 23C5.935 23 1 18.065 1 12S5.935 1 12 1s11 4.935 11 11-4.935 11-11 11z" _fill="#766E6A"/><path pid="1" d="M15.854 8.146a.5.5 0 0 0-.707 0L12 11.293 8.854 8.146a.5.5 0 0 0-.707.707L11.293 12l-3.146 3.146a.5.5 0 0 0 .707.708L12 12.707l3.146 3.146a.5.5 0 1 0 .708-.706L12.707 12l3.146-3.146a.5.5 0 0 0 .001-.708z" _fill="#766E6A"/>'
  }
})
